// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

BCSfFilter.prototype.buildSuggestionProductPrice = function(data) {
    /* Multi-currency Shopify */
    var self = this;
    self.prepareSuggestionProductPriceData(data);
    
    // Check on sale
    var onSale = data.compare_at_price_min > data.price_min;
    // Format price
    var price = this.formatMoney(data.price_min * 100),
        compareAtPrice = this.formatMoney(data.compare_at_price_min * 100);
    if (this.getSettingValue('search.removePriceDecimal')) {
        price = this.removeDecimal(price);
        compareAtPrice = this.removeDecimal(compareAtPrice);
    }
    // Build Price
    var result = '';
    if (this.getSettingValue('search.showSuggestionProductPrice')) {
        result += '<div class="' + this.class.searchSuggestion + '-product-price">';
        if (onSale && this.getSettingValue('search.showSuggestionProductSalePrice')) {
            result += '<s>' + compareAtPrice + '</s>  ';
            result += '<span class="money pre-money" data-product-id="'+data.id+'">' + price + '</span>';
        } else {
            result += '<span class="money pre-money" data-product-id="'+data.id+'">' + price + '</span>';
        }
        result += '</div>';
    }
    return result;
};